import { msg } from "@lingui/core/macro";
import { useLingui } from "@lingui/react";
import { useId } from "react";

import { ToggleGroup, ToggleGroupItem } from "@/shared/ui/toggle-group";

import type { MapMode } from "../../map/MapMode";

const LABEL = msg({ id: "analysis.map.mode_label", message: "Where you were:" });
const ALL = msg({ id: "analysis.map.mode.whole", message: "whole match" });
const UPTO = msg({ id: "analysis.map.mode.until", message: "up to the moment" });

type MapModeToggleProps = {
  mode: MapMode;
  onChange: (mode: MapMode) => void;
};

// «Где ты был»: тепло за весь матч или только до выбранного момента.
// На узком экране — на всю ширину.
export const MapModeToggle = ({ mode, onChange }: MapModeToggleProps) => {
  const { _ } = useLingui();
  const labelId = useId();
  return (
    <div className="flex items-center gap-2 @max-lg:w-full">
      <span id={labelId} className="shrink-0 text-xs text-subtle">
        {_(LABEL)}
      </span>
      <ToggleGroup
        type="single"
        aria-labelledby={labelId}
        value={mode}
        onValueChange={(value) => {
          if (value === "all" || value === "upto") {
            onChange(value);
          }
        }}
        className="@max-lg:grid @max-lg:flex-1 @max-lg:grid-cols-2"
      >
        <ToggleGroupItem value="all">{_(ALL)}</ToggleGroupItem>
        <ToggleGroupItem value="upto">{_(UPTO)}</ToggleGroupItem>
      </ToggleGroup>
    </div>
  );
};
